// src/components/AppHeader.js — 공용 상단 바: 로고 클릭 → 홈, 프로필·로그아웃 (홈·일기 페이지 공용)
import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { logout } from '../utils/storageUtils';
import '../styles/AppHeader.css';

const AppHeader = () => {
    const navigate = useNavigate();
    const location = useLocation();
    // 프로필 화면에서 "프로필" 버튼은 자기 자신으로의 이동이라 숨긴다
    const isOnProfile = location.pathname === '/profile';

    return (
        <header className="app-header">
            <div className="app-header-content">
                <button className="app-logo" onClick={() => navigate('/home')} aria-label="홈으로 이동">
                    ReUs
                </button>
                <div className="app-header-actions">
                    {!isOnProfile && (
                        <button className="app-profile-btn" onClick={() => navigate('/profile')}>
                            프로필
                        </button>
                    )}
                    <button className="app-logout-btn" onClick={() => logout()}>
                        로그아웃
                    </button>
                </div>
            </div>
        </header>
    );
};

export default AppHeader;
